import { request } from 'src/common/rest/index';

let baseUrl = '';
export const setBaseUrl = value => {
  baseUrl = value;
};

export const newsletter = data => {
  return request.post(
    `${baseUrl}/website/v2/subscriptions/sign_up_to_newsletter`,
    JSON.stringify(data),
    {
      headers: {
        'content-type': 'application/json'
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/client/js/facades/eagle/subscriptions.js